import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BasemodelService {
  data: any;
  AttendanceUrl: any = "";
  Commonurl: any = "";
  cctvURL: any = "";
  moduleBaseURl: any[] = [];
  counselling: any = '';
  acadmiUrl: any = '';
  MerkiUrl: any = ''
  receiptcancelling: any = '';
  webService: any;

  constructor(private http: HttpClient) {
    // Assuming you get the API response and set `moduleBaseURl`

    // Set URLs from the API response

  }

  async getURLS(): Promise<any> {
    try {
      const res = await lastValueFrom(
        this.http.get(environment.employeeURL + '/jwtV2/api/common/moduleBaseUrls')
      );
      this.data = res;
      this.setModuleUrls();
      return res;  // Optionally return the result if needed
    } catch (err) {
      console.error('Error fetching moduleBaseUrls', err);
      throw err;  // Handle error appropriately
    }
  }
  // Method to set the URLs
  setModuleUrls() {
    for (let i = 0; i < this.data.moduleBaseURl.length; i++) {
      const moduleData = this.data.moduleBaseURl[i];

      switch (moduleData.basemodule) {
        case "StudentAttendance":
          localStorage.setItem("StudentAttendance", moduleData.baseurl);
          this.AttendanceUrl = moduleData.baseurl;
          break;

        case "CCTVDashboard":
          // localStorage.setItem("CCTVDashboard", moduleData.baseurl);
          this.cctvURL = moduleData.baseurl
          break;

        case "MasterService":
          localStorage.setItem("MasterService", moduleData.baseurl);
          this.Commonurl = moduleData.baseurl;
          break;

        case "MisService":
          localStorage.setItem("MisService", moduleData.baseurl);
          break;

        case "MerakiDashboard":
          localStorage.setItem("MerakiDashboard", moduleData.baseurl);
          break;

        case "WebService":
          localStorage.setItem("WebService", moduleData.baseurl);
          this.webService = moduleData.baseurl
          break;

        default:
          console.warn(`Unknown module: ${moduleData.basemodule}`);
      }

    }
    this.getAttendanceUrl()
  }
  getAttendanceUrl() {
    return this.AttendanceUrl || localStorage.getItem("StudentAttendance");
  }
  getCommonUrl() {
    return this.Commonurl || localStorage.getItem("MasterService");
  }
  getcctv() {
    return this.cctvURL || localStorage.getItem("CCTVDashboard")
  }
  getcounsellingURL() {
    return this.counselling || localStorage.getItem("WebService");
  }
  getacadmicURL() {
    return this.acadmiUrl || localStorage.getItem("WebService");
  }
  getWifiURL() {
    return localStorage.getItem("WebService");
  }
  getreceiptcancellingURL() {
    return this.receiptcancelling || localStorage.getItem("WebService");
  }
  getmerakiUrl() {
    return this.MerkiUrl || localStorage.getItem("MerakiDashboard");
  }
  getmagration() {
    return this.MerkiUrl || localStorage.getItem("MisService");
  }



}
